<template>
  <div id="app">
    <div ref="newCatalog" class="newCatalog">
    <Header></Header>
    <router-view/>
    <Footer></Footer>
    <GoTop></GoTop>
  </div>
</div>
</template>

<script>
export default {
  name: 'App',
  data(){
    return {
      scale: ''
    }
  },
  mounted() {
    this.setScale()
    window.addEventListener('resize', this.setScale);
    debugger;
    // if (this._isMobile()) {
    //   alert("手机端");
    //   this.$router.replace('/solution/ss1');
    // } else {
    //   alert("pc端");
    //   this.$router.replace('/solution/ss2');
    // }
  },
  methods: {
    getScale() {
      const width = window.screen.width
      const height = window.screen.height
      let ww = window.innerWidth / 1920
      let wh = window.innerHeight / 1080
      return ww < wh ? ww : wh
    },
    setScale() {
      this.scale = this.getScale()
      this.$refs.newCatalog.style.setProperty('--scale', this.scale)
    },
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    }
  }
  }
</script>

<style lang="scss">

// @import '~style/init.scss';
@media screen and (max-width: 980px){
          #newCatalog{width: 90%;margin: 0 auto;}
        }
#app {
  width: 100vw;
  height: 100vh;
  font-family: Alibaba-PuHuiTi-R, Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  // background: url('~assets/images/bg.png');
  background-size: cover;
}
.newCatalog {
  // --scale: 1;
 // width: 1530px;
//  height: 1080px;
  width: 100%;
  height: 100%;
  background-size: 100% 100%;
  position: absolute;
  // transform: scale(1,1) ;
  display: flex;
  flex-direction: column;
  // transform-origin: 0 0;
  // left: -10%;
  // top: 50%;
}
// ::-webkit-scrollbar {
//   width: 0 !important;
// }
// ::-webkit-scrollbar {
//   width: 0 !important;height: 0;
// }
</style>



// WEBPACK FOOTER //
// src/App.vue